import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './toolboxSelect.css';

const ToolboxSelect = ({ items, active, onChange, fullId }) => (
  <div className={styles.selectWrapper}>
    <select
      className={styles.select}
      value={active}
      onChange={({ target: { value } }) => onChange(value, fullId)}
    >
      {items.map(({ label, comparator }) => (
        <option
          key={label}
          value={comparator}
        >
          {label}
        </option>
      ))}
    </select>
  </div>
);

ToolboxSelect.defaultProps = {
  fullId: undefined,
};

ToolboxSelect.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      comparator: PropTypes.string.isRequired,
    })
  ).isRequired,
  active: PropTypes.string.isRequired,
  fullId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ToolboxSelect;
export { ToolboxSelect };



// WEBPACK FOOTER //
// ./app/components/toolboxSelect/index.js